import { IIrvResultScore } from '@/shared/api-client/models/irv-result-score';
import GenderIconComponent from '@/shared/components/gender-icon-component/gender-icon-component.vue';
import { Component } from 'vue-property-decorator';
import BaseElectionResultListComponent from '../base-result-list-component';

@Component({
    components: {
        GenderIconComponent
    }
})
export default class IrvElectionResultListComponent extends BaseElectionResultListComponent<IIrvResultScore> {


}
